// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

var highlightColour = Theme__Color$PrezzeeRibbon.Business.prezzeePurple;

var headingColour = Theme__Color$PrezzeeRibbon.Business.charcoal;

var Theme = {
  highlightColour: highlightColour,
  headingColour: headingColour
};

export {
  Theme ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
